import angular from '../bower_components/angular'
import 'script!../bower_components/mapbox.js/mapbox.js'
import 'script!../bower_components/jquery/dist/jquery.min.js'
import routing from './app.route'
import projects from './projects'
import asideCtrl from './asideCtrl'
import welcomeCtrl from './welcome/welcomeCtrl'
import headerCtrl from './headerCtrl'
import GlobalSrv from './globalSrv'
import ModalSrv from './partials/modalSrv'
import R from 'ramda'

import { onlyInteger, errSrc } from './app.directives'

let localenvjson = require('../local.env.json')
let globalConfig = require('./globals/globalConfig.json')
let cssClasses = require('./globals/cssClasses.json')

// require("fullcalendar");
// require('./srcangularUtils.directives.dirPagination')
// require('../bower_components/angular-file-upload/angular-file-upload.min.js');
// require('../bower_components/textAngular/dist/textAngular.min.js');
// require('../bower_components/venturocket-angular-slider/build/angular-slider.js');
// require('moment');
// require('../bower_components/angular-dragdrop/src/angular-dragdrop.js');
// require('../bower_components/slick-carousel/slick/slick.js');
// require('../bower_components/select2/select2.css');
// require('../bower_components/select2/select2.js');
// require('../bower_components/angular-ui-select2/src/select2.js');
// require('../bower_components/angular-ui-select/dist/select.js');

require('jquery-ui')
require('bootstrap')
require('ngImgCrop')
require('animate.css')
require('datatables')
require('footable')
require('waves')
require('pivottable')
require('slick-carousel')
require('c3')
require('textAngular')
require('select2')
require('bootstrap-daterangepicker')
require('ng-notify')
require('ngstorage')
require('oclazyload')
require('d3')
require('lodash')
require('desandro-matches-selector')
require('ng-csv')
require('angular-file-upload')
require('slick-carousel')
require('angular-material')
require('angular-loading-bar')
require('angular-bootstrap-nav-tree')
require('angular-xeditable')
require('angular-animate')
require('angular-aria')
require('angular-messages')
require('angular-touch')
require('angular-ui-select2')
require('angular-ui-select')
require('angular-translate')
require('angular-bootstrap-grid-tree')
require('angular-translate-loader-static-files')
require('angular-cookies')
require('angular-translate-storage-cookie')
require('angular-translate-storage-local')
require('angular-bootstrap')
require('angular-loading-bar')
require('angular-bootstrap-nav-tree')
require('angular-ui-router')
require('angular-ui-utils')
require('angular-bootstrap-contextmenu')
require('angular-filter')
require('angular-ui-map')
require('angular-resource')
require('angular-sanitize')
require('angular-socket-io')
require('angular-validation-match')
require('angular-chat')
require('angular-slick')
require('angular-disable-all')
require('angularUtils-pagination')
require('angular-daterangepicker')
require('ng-youtube-embed')
require('ng-file-upload')
require('angular-masonry')
require('pdfmake')
require('angular-base64')
// Licensed Services
require('./services/ngbreadcrumb.js')
require('./services/permissionIndex')

// Bower Modules
require('../bower_components/angular-ui-grid/ui-grid.js')
require('../bower_components/angular-ui-grid/ui-grid.css')
require('../bower_components/pivottable/dist/c3_renderers.js')
require('../bower_components/pivottable/dist/d3_renderers.js')
require('../bower_components/pivottable/dist/export_renderers.js')
// require('../bower_components/font-awesome/css/font-awesome.css')
require('../bower_components/css-percentage-circle/css/circle.css')
require('../bower_components/angular-bootstrap-calendar/dist/css/angular-bootstrap-calendar.min.css')
require('script!../bower_components/angular-ui-utils/ui-utils.js')
require('script!../bower_components/proj4/dist/proj4.js')
require('script!../bower_components/highcharts/highcharts.js')
require('script!../bower_components/highcharts/highcharts-more.js')
require('script!../bower_components/highcharts/modules/data.js')
require('script!../bower_components/highcharts/modules/map.js')
require('script!../bower_components/highcharts/modules/exporting.js')
require('script!../bower_components/highcharts-ng/dist/highcharts-ng.js')
require('script!../bower_components/moment/moment.js')
require('script!../bower_components/moment/locale/es.js')
require('script!../bower_components/angular-bootstrap-calendar/dist/js/angular-bootstrap-calendar-tpls.js')
require('script!../bower_components/angular-clipboard/angular-clipboard.js')
require('../bower_components/angular-bootstrap-calendar/dist/css/angular-bootstrap-calendar.min.css')
require('script!../bower_components/pdfmake/build/pdfmake.min.js')
require('script!../bower_components/pdfmake/build/vfs_fonts.js')

window.pdfmake = {}

window.taTools = {}
require('../bower_components/textAngular/dist/textAngular.css')
require('script!../bower_components/textAngular/dist/textAngular-rangy.min.js')

require('script!../bower_components/rltm/web/rltm.js')
require('script!../bower_components/angular-scroll-glue/src/scrollglue.js')
// require('angular-chat')

// funcionalidad para exportal una tabla html a excel
require('script!../node_modules/@linways/table-to-excel/dist/tableToExcel.js')

//require file script and variable for switch styles according to customer
const clientName = localenvjson.clientName

try {
	require(`./assets/stylesheets/app-${clientName}.less`)
} catch (error) {
	require('./assets/stylesheets/app-uplanner.less')
}

import myDirective from './services/userAuth.directive.js'
import * as pbi from '../bower_components/powerbi-client/dist/powerbi.js'
window['powerbi-client'] = pbi

import powerBiSrv from './services/powerBiSrv'
import loginController from './login/loginController'
import loginErrorMessageController from './login/loginErrorMessageController'
import Helpers from './helpers'

angular.module('app', [
	// 'ui.load',
	// 'ui.jp',
	'chat',
	'btford.socket-io',
	'validation.match',
	'pascalprecht.translate',
	'angular-loading-bar',
	'angular.filter',
	'textAngular',
	'xeditable',
	'highcharts-ng',
	'treeGrid',
	'angularUtils.directives.dirPagination',
	'daterangepicker',
	'disableAll',
	'slick',
	'uplannerPermission',
	'angularFileUpload',
	'mwl.calendar',
	'ngNotify',
	'ngCsv',
	'ngAnimate',
	'ngAria',
	'ngCookies',
	'ngMessages',
	'ngMaterial',
	'ngResource',
	'ngSanitize',
	'ngTouch',
	'ngMaterial',
	'ngStorage',
	'ngBreadCrumb',
	'ui.router',
	'ui.select2',
	'ui.select',
	'ui.router',
	'ui.utils',
	'ui.bootstrap',
	'ui.map',
	'ui.grid',
	'ui.grid.selection',
	'ui.grid.treeView',
	'ui.grid.grouping',
	'ui.grid.exporter',
	'ui.bootstrap.contextMenu',
	'ui.grid.expandable',
	'ui.grid.pinning',
	'ui.grid.pagination',
	'luegg.directives',
	'ngYoutubeEmbed',
	'ngFileUpload',
	'wu.masonry',
	'angular-clipboard',
	'base64',
	projects,
	GlobalSrv,
	ModalSrv,
	'report',
	powerBiSrv,
	Helpers,
])
	.config(routing) // router for the aside menu of the app
	.controller('AsideCtrl', asideCtrl) // controller for the aside menu of the app
	.controller('HeaderCtrl', headerCtrl) // controller for the header of the app
	.controller('welcomeCtrl', welcomeCtrl) // controller for the header of the app
	.controller('loginController', loginController)
	.controller('loginErrorMessageController', loginErrorMessageController)
	.value('permissionList', [ { details: [] } ]) // user permissions list
	.constant('Ramda', R)
	.constant('MenuConstant', [ { menu: [] } ])
	.constant('ClientBaseFilePathConstant', [ { constant_url: [] } ])
	.constant('UserInfoConstant', [ { details: [] } ])
	.constant('GlobalConfig', globalConfig)
	.constant('CssClasses', cssClasses)
	.constant('SERVICE_URL_CONSTANT', localenvjson.SERVICE_URL_CONSTANT)
	.constant('LOCAL_ENV_CONSTANT', localenvjson)
	.run([ '$rootScope', '$templateCache', '$state', '$stateParams', '$timeout', 'permissions', 'permissionList', '$location',
		function ($rootScope, $templateCache, $state, $stateParams, $timeout, permissions, permissionList, $location) {
			// console.log('permissions', permissions)
			$templateCache.put('aside.nav.uikit.html', require('./partials/aside.nav.uikit.html'))
			$templateCache.put('ngBreadCrumbTemplate.html', require('./layout/ngBreadCrumbTemplate.html'))
			$templateCache.put('setupErrorModal', require('./partials/setupErrorModal.html'))
			$rootScope.$state = $state
			$rootScope.$stateParams = $stateParams

			if ($location.path() == '/' || $location.path() == '/app') {
				$location.path('/app/welcomeHome')
			}
		},
	])
	.directive('onlyInteger', onlyInteger)
	.directive('errSrc', errSrc)
angular.module('chat').constant('config', {
	rltm: {
		service: 'pubnub',
		config : {
			publishKey  : 'pub-c-a911f2d1-f798-4bea-beb9-2417ca348fe9',
			subscribeKey: 'sub-c-3f8e8e40-f201-11e6-bba1-0619f8945a4f',
		},
	},
}).directive('powerbiScopeWithController', function () {
	var controller = [ '$scope', '$http', '$timeout', '$localStorage', 'LOCAL_ENV_CONSTANT', function ($scope, $http, $timeout, $localStorage, LOCAL_ENV_CONSTANT) {
			function init() {
				if (typeof $scope.WORKSPACEID === 'undefined') {
					return false
				}

				var selectedWorkspace = $scope.WORKSPACEID

				if (typeof $localStorage.embeded === 'undefined')
					var expiry = false
				else
					var expiry = parseInt($localStorage.embeded.expires_on)

				var offset = 300

				// expiry=1511196676 
				console.log(expiry, 'expirytime', Math.round(new Date().getTime() / 1000.0) + offset)

				if (expiry && (expiry > Math.round(new Date().getTime() / 1000.0) + offset)) {
				// console.log(expiry,'tttt',Math.round(new Date().getTime() / 1000.0) + offset)
				// return true
				// delete $localStorage.embeded
				} else {
					delete $localStorage.embeded
				}

				var getItems = $localStorage.embeded

				if (typeof getItems === 'undefined') {
					$http({
						crossDomain: true,
						xhrFields  : { withCredentials: false },
						headers    : {
							'Accept'      : 'application/json',
							'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
						},
						method: 'POST',
						// data:$.param(param),
						url   : LOCAL_ENV_CONSTANT.POWERBI_CONSTANT.API_URL,
					}).then(function (response) {
						var data = response.data.data
						// console.log("sample: "+JSON.stringify(data));
						var tokenAttributes = JSON.parse(data)
						var token = tokenAttributes.access_token

						$localStorage.embeded = tokenAttributes

						getReport(selectedWorkspace, token)

						//  // Get the list of reports
					}, function (response) {
						console.log('Error:   ' + JSON.stringify(response))
					})
				} else {
					getReport(selectedWorkspace, getItems.access_token)
				}
			}

			init()

			function getReport(selectedWorkspace, token) {
				$timeout(() => {
					$http.get('https://api.powerbi.com/v1.0/myorg/' + (selectedWorkspace ? 'groups/' + selectedWorkspace + '/reports' : 'reports')
						, {
							headers: {
								'Authorization': 'Bearer  ' + token,
								'Content-Type' : 'application/json; charset=utf-8',
							},
						}).then(function (response) {
						$scope.reports = response.data.value

						for (var i in $scope.reports) { //'U-Forecast Datos'
							if ($scope.reports[i].name == $scope.REPORTID) {
								$scope.selectedReport = $scope.reports[i]
							}
						}
						// $scope.selectedReport = $scope.reports[0].embedUrl;

						var models = window['powerbi-client'].models
						var embedConfiguration = {
							type       : 'report',
							accessToken: token,
							embedUrl   : $scope.selectedReport.embedUrl,
							permissions: models.Permissions.All,
							settings   : {
								filterPaneEnabled    : false,
								navContentPaneEnabled: true,
							},
							pageView: 'fitToWidth',
						}

						var $reportContainer = $('#embedContainer')

						var report = powerbi.embedNew($reportContainer.get(0), embedConfiguration)

						$timeout(function () {
							document.getElementById('embedContainer').style.height = (window.innerHeight - 10) + 'px'
						}, 1000)

						$(window).resize(function () {
							document.getElementById('embedContainer').style.height = (window.innerHeight - 10) + 'px'
						})
					}, function (error) {
						$scope.reportError = error
					})
				}, 2000)
			}
		} ],

		template = '<div id="embedContainer" style="height: 600.823px;"></div>'

	return {
		restrict: 'EA', //Default in 1.3+
		scope   : {
			datasource : '=',
			add        : '&',
			WORKSPACEID: '@workspaceid',
			REPORTID   : '@reportid',
		},
		controller: controller,
		template  : template,
	}
})



// WEBPACK FOOTER //
// ./src/app.js